// extracted by mini-css-extract-plugin
export default {"ErrorPage":"ErrorPage_ErrorPage__VR4+E","ErrorPage__inner":"ErrorPage_ErrorPage__inner__t92nj"};